<template>
    <CModal :title="title" :show.sync="importModal" centered fade class="disable-footer disable-header"
        :closeOnBackdrop="false">
        <div class="popup-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" @click="handleClose">
                <CIcon name="cil-x" />
            </button>
        </div>
        <br />
        <CSelect v-if="isClientSelectVisible()" label="Client" placeholder="Select a client" :options="clientList"
            horizontal :value.sync="selectedClient" id="select" />


        <div v-for="(data, index) in filesInfo" v-bind:key="data.type" class="form-group form-row">
            <CRow>
                <label class="col-form-label col-sm-3">{{ data.label }}</label>
                <CCol sm="6">
                    <CInputFile :disabled="progressValue !== 0"
                        @change="(f, event) => filesChangeHandler(f, index, event)"
                        :description="'Choose a csv file and hit upload. Max file size: 100MB. \nUse the template file to import'"
                        :id="`fileInput-${index}`" accept=".csv" />
                </CCol>
                <CCol class="pr-0">
                    <CLink @click="downloadTemplate(data.type)">Template File</CLink>
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="3"></CCol>
                <CCol class="custom-col">
                    <div v-if="invalidFileExt[index]" class="invalid-feedback mt-0" style="display: block !important">
                        Invalid file extension, Please upload a
                        <strong>csv</strong> file
                    </div>
                    <div v-if="largeFile[index]" class="invalid-feedback mb-3 mt-0" style="display: block !important">
                        File size is to large, Please upload a file less than
                        <strong>100MB</strong>
                    </div>
                </CCol>
            </CRow>
        </div>

        <template v-if="uploadStarted">
            <div class="float-right">{{ progressValue }}%</div>
            <CProgress :value="progressValue" size="sm" animated color="success" style="height: 5px; width: 100%"
                class="mb-3" />
        </template>
        <h6 v-if="errorMsg" class="error">
            {{ errorMsg }}
        </h6>
        <h6 v-if="progressValue === 100">
            File uploaded to our server. We will notify you once it is imported
            to the database
        </h6>

        <div class="inactive-modal-response">
            <template v-if="progressValue === 100">
                <CButton type="submit" color="secondary" class="m-1 float-right" @click="handleClose">Ok</CButton>
            </template>
            <template v-if="!uploadStarted">
                <CButton type="submit" color="primary" class="m-1 float-right"
                    :disabled="!allFilesAdded || !selectedClient" @click="handleFileUpload">Upload</CButton>
                <CButton type="submit" color="secondary" class="m-1 float-right" @click="handleClose">Cancel</CButton>
            </template>
        </div>
    </CModal>
</template>

<script>
import { storeData } from "../../store";
import gql from "graphql-tag";

const FILE_UPLOAD_STATUS = gql`
    mutation (
        $fileName: String!
        $type: String!
        $client_id: uuid
        $created_on: timestamp
    ) {
        insert_spendmd_db_file_upload_status(
            objects: {
                fileName: $fileName
                type: $type
                client_id: $client_id
                created_on: $created_on
            }
        ) {
            returning {
                id
            }
        }
    }
`;
const GET_CLIENTS_LIST = gql`
    query MyQuery {
        spendmd_db_clients(where: { name: { _neq: "SpendMD" } }) {
            id
            name
        }
    }
`;
import UploadFiles from "../../utility/uploadFiles";
import XLSX from "xlsx";
import _ from "../Utility/utility";

export default {
    props: {
        modal: Boolean,
        title: String,
        filesInfo: Array,
        selectClient: Boolean,
    },
    data() {
        return {
            importModal: false,
            files: [],
            progressValue: 0,
            clientList: [],
            selectedClient: null,
            uploadStarted: false,
            invalidFileExt: [],
            largeFile: [],
            errorMsg: "",
            allFilesAdded: false,
        };
    },
    computed: {
        importProgress() {
            return this.$store.state.importProgress;
        },
        isSysAdmin() {
            return storeData.currentUserDetails.role.name === "sys_admin";
        },
        isGroupAdmin() {
            return storeData.currentUserDetails.role.name === "group_admin";
        },
    },
    watch: {
        modal() {
            this.$store.commit("set", ["importProgress", 0]);
            this.importModal = this.modal;
        },
        importProgress(val) {
            this.progressValue = val;
        },
        filesInfo() {
            for (let index = 0; index < this.filesInfo.length; index++) {
                this.files.push(null);
                this.invalidFileExt.push(false);
                this.largeFile.push(false);
            }
        }
    },
    methods: {
        downloadTemplate(type) {
            let templateData = null;
            if (type === "ap-spend-data") {
                templateData = AP_TEMPLATE;
            } else if (type === "po-spend-data-two") {
                templateData = PO_TEMPLATE;
            } else {
                return;
            }

            const templateArray = [];
            templateArray.push(templateData);

            const exportData = XLSX.utils.json_to_sheet(templateArray);
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, exportData, "Data");
            XLSX.writeFile(workBook, `${type}-template.csv`);
        },
        filesChangeHandler(f, index) {
            this.files[index] = f;
            this.invalidFileExt[index] = false;
            this.largeFile[index] = false;

            this.allFilesAdded = this.files.some(f => !!f && f.length > 0);
        },
        isClientSelectVisible() {
            if (this.selectClient) {
                if (this.isSysAdmin || this.isGroupAdmin) return true;
                else return false;
            } else {
                return false;
            }
        },
        handleFileUpload() {
            this.errorMsg = "";
            if (
                this.selectedClient == null ||
                this.selectedClient == false ||
                this.selectedClient == undefined ||
                this.selectedClient == ""
            ) {
                this.errorMsg = "Please select a client";
                return;
            } else {
                // Extracting extension from file name
                const re = /(?:\.([^.]+))?$/;
                for (let i = 0; i < this.files.length; i++) {
                    const fileExtension = re.exec(this.files[i][0].name)[1];
                    const fileSize = Math.round(this.files[i][0].size / 1024); // in KB

                    if (fileExtension.toLowerCase() !== "csv") {
                        this.invalidFileExt[i] = true;
                    } else if (fileSize > 102400) {
                        // 100 MB
                        this.largeFile[i] = true;
                    } else {
                        this.uploadStarted = true;
                        this.invalidFileExt[i] = false;
                        this.largeFile[i] = false;

                        const file = this.files[i][0];
                        const reader = new FileReader();
                        reader.onabort = () => {
                            console.log(
                                "File reading aborted for some reason, Please try again"
                            );
                        };
                        reader.onerror = (err) => {
                            console.log("file reading has failed", err);
                        };
                        reader.onload = async () => {
                            // For client_admin or client_users
                            if (
                                storeData.currentUserDetails.role.name ===
                                "client_admin" ||
                                storeData.currentUserDetails.role.name ===
                                "client_user"
                            ) {
                                this.selectedClient =
                                    storeData.currentUserDetails.client_id;
                            }

                            //** todo temp hardcode client id for test */
                            if (this.filesInfo[i].type === "opportunity-data") {
                                this.selectedClient = "a8361072-903b-444f-b5d3-5e8c02d0db18";
                            }

                            let uploadFiles = new UploadFiles();
                            console.log(this.selectedClient);

                            const uploadRes = await uploadFiles.init(
                                reader.result,
                                file,
                                this.filesInfo[i].type,
                                this.selectedClient
                            );

                            if (uploadRes) {
                                // Add file status to db
                                this.$apollo
                                    .mutate({
                                        mutation: FILE_UPLOAD_STATUS,
                                        variables: {
                                            fileName: file.name,
                                            type: this.filesInfo[i].type,
                                            client_id: this.selectedClient,
                                            created_on: _.getUTCTimestamp(),
                                        },
                                    })
                                    .then((res) => {
                                        const result =
                                            res.data
                                                .insert_spendmd_db_file_upload_status
                                                .returning;
                                        if (result[0].id > 0)
                                            console.log(`file ${i} upload status added`);
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    });
                            } else {
                                // Show failed response in modal
                                this.errorMsg = "Something went wrong while trying to upload the file, sign out and try again in a new tab.";
                            }
                        };
                        reader.readAsArrayBuffer(file);
                    }
                }
            }
        },
        handleClose() {
            this.importModal = false;
            this.reset();
            this.$emit("close");
        },
        reset() {
            if (document.getElementById("select"))
                document.getElementById("select").selectedIndex = 0;

            for (let index = 0; index < this.filesInfo.length; index++) {
                document.getElementById(`fileInput-${index}`).value = "";
                this.files[index] = null;
                this.invalidFileExt[index] = false;
                this.largeFile[index] = false;
            }

            this.uploadStarted = false;
        },
    },
    async beforeMount() {
        this.importModal = false;

        this.clientList = [];
        const res = await this.$apollo.mutate({
            mutation: GET_CLIENTS_LIST,
        });

        const result = res.data.spendmd_db_clients;
        for (const el of result) {
            this.clientList.push({
                label: el.name,
                value: el.id,
            });
        }

        // For client_admin or client_users
        if (
            storeData.currentUserDetails.role.name === "client_admin" ||
            storeData.currentUserDetails.role.name === "client_user"
        ) {
            this.selectedClient = storeData.currentUserDetails.client_id;
        }
    },
};

const AP_TEMPLATE = {
    client: "",
    ap_start: "",
    ap_end: "",
    vendor_id: "",
    vendor_name: "",
    total_spend: "",
    out_of_scope: "",
    prime_category: "",
    secondary_category: "",
    sub_category: ""
};

const PO_TEMPLATE = {
    client: "",
    po_start: "",
    po_end: "",
    vendor_id: "",
    vendor_source: "",
    vendor_parent: "",
    vendor_division: "",
    manufacturer_source: "",
    manufacturer_parent: "",
    manufacturer_division: "",
    primary_category: "",
    secondary_category: "",
    sub_category: "",
    out_of_scope: "",
    contract: "",
    vendor_catalog: "",
    manufacturer_catalog: "",
    item_description: "",
    uom: "",
    factor: "",
    quantity: "",
    purchase_date: "",
    cost: "",
    total_spend: ""
};
</script>

<style>
.custom-col {
    padding-left: 10px;
    padding-top: 0px;
}

.custom-col1 {
    padding-left: 10px;
    padding-top: 15px;
    padding-bottom: 5px;
}

.error {
    color: #ff6700;
}
</style>
